
import styled from './Footer.module.css';

const Footer = () => {


        return(

            
            <div className={styled.containerFoot}>
            <footer className={styled.foot}>Derechos Reservados © Comercializadora Autocolor ANGEL 21</footer>      
            </div>

        )

}


export default Footer;